<template lang="pug">
.Typeahead
  i.fa.fa-spinner.fa-spin(v-if='loading')
  template(v-else='')
    i.fa.fa-search(v-show='isEmpty')
    i.fa.fa-times(v-show='isDirty', @click='reset')

  input.form-control(
    type='text',
    placeholder='Add customer by name',
    autocomplete='off',
    v-model='query',
    ref='input',
    :class="inputClass",
    @keydown.down='down',
    @keydown.up='up',
    @keydown.enter='hit',
    @keydown.esc='reset',
    @blur="reset",
    @input='update')

  ul.list-group.position-absolute(v-show='hasItems', style="z-index: 2")
    li.list-group-item.d-flex.justify-content-between.align-items-center(
      v-for='(item, $item) in items',
      :key='item.id',
      :class='activeClass($item)',
      @mousedown='hit',
      @mousemove='setActive($item)')
      strong(v-text='item.name')
      span.badge.badge-pill.badge-secondary Policies {{ item.policies_count }}
</template>

<script>
import VueTypeahead from 'vue-typeahead'
import config from '@/config/global.config'

export default {
  name: 'CustomerSearch',
  extends: VueTypeahead,

  props: {
    size: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      src: `${config.appUrl}/commission/employee/customers/`,
      minChars: 3,
      selectFirst: true,
      queryParamName: false
    }
  },

  computed: {
    inputClass () {
      return this.size ? `form-control-${this.size}` : ''
    }
  },

  methods: {
    onHit (item) {
      this.$emit('onHit', item)
      this.$refs.input.blur()
    },

    prepareResponseData (data) {
      console.info(data)
      return data
    }
  }
}
</script>

<style lang="sass" scoped>
  .active
    color: black
</style>
